import { render, staticRenderFns } from "./MFormText.vue?vue&type=template&id=ee703818&"
import script from "./MFormText.vue?vue&type=script&lang=js&"
export * from "./MFormText.vue?vue&type=script&lang=js&"
import style0 from "./MFormText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports